import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const User = {
  createUser: (data) =>
    request.post(`/user`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getUserById: (id) =>
    request.get(`/user/id/${id}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getUserByEmail: (email) =>
    request.get(`/user/email/${email}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getUsers: (lastId, type, navId, lookupStrng) =>{
    let params = new URLSearchParams();
    if (type) params.append("userType", type);
    if (lastId) params.append(navId, lastId);
    if (lookupStrng) params.append("lookupStrng", lookupStrng);
      return request.get(`/user?${params.toString()}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${getAccessToken()}`
        }
      });
  },
  
  getUsersGeneric: (data) =>
    request.put(`/user/generic`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateUserById: (id, data) =>
    request.patch(`/user/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateUserByEmail: (data, email) =>
    request.patch(`/user/email/${email}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateUsersGeneric: (data) =>
    request.patch(`/user/generic`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  addProfile: (id, data) =>
    request.put(`/user/profile/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updatePassword: (email, password) =>
    request.patch(`/updatepassword/password/${email}`, password, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default User;
